import styled from 'styled-components';

export const ButtonText = styled.p`
  margin: 0;
  flex-grow: 1;
  text-align: center;
  padding: 15px;
  font-size: 15px;
`;
